// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ClickableBase.module.scss  */
.ClickableBase-module-Root_10t {
  width: 100%;
  padding: unset;
  font-size: unset;
  text-align: unset;
  text-decoration: none;
  color: unset;
  border: 0;
  background-color: transparent; }
  .ClickableBase-module-Root_10t:hover {
    cursor: pointer;
    opacity: 0.8; }
  .ClickableBase-module-Root_10t[aria-selected='true'], .ClickableBase-module-Root_10t[data-selected='true'] {
    background-color: #f9f9f9; }
  .ClickableBase-module-Root_10t[disabled], .ClickableBase-module-Root_10t[aria-disabled='true'] {
    cursor: not-allowed;
    pointer-events: none; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/_internal_/components/ClickableBase/ClickableBase.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,6BAA6B,EAAE;EAC/B;IACE,eAAe;IACf,YAAY,EAAE;EAChB;IACE,yBAAyB,EAAE;EAC7B;IACE,mBAAmB;IACnB,oBAAoB,EAAE","sourcesContent":["/*  imported from ClickableBase.module.scss  */\n.ClickableBase-module-Root_10t {\n  width: 100%;\n  padding: unset;\n  font-size: unset;\n  text-align: unset;\n  text-decoration: none;\n  color: unset;\n  border: 0;\n  background-color: transparent; }\n  .ClickableBase-module-Root_10t:hover {\n    cursor: pointer;\n    opacity: 0.8; }\n  .ClickableBase-module-Root_10t[aria-selected='true'], .ClickableBase-module-Root_10t[data-selected='true'] {\n    background-color: #f9f9f9; }\n  .ClickableBase-module-Root_10t[disabled], .ClickableBase-module-Root_10t[aria-disabled='true'] {\n    cursor: not-allowed;\n    pointer-events: none; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
